import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import {Avatar, Button, Grid, makeStyles} from '@material-ui/core';
import {Person, Delete} from '@material-ui/icons';
type agent = {
    firstName: string;
    lastName: string;
    email: string;
    handleDelete?: () => void;
};
const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        maxWidth: 480,
        backgroundColor: theme.palette.background.paper,
    },
    container: {
        backgroundColor: theme.palette.background.paper,
    },
}));
export default function AgentInfo(props: agent) {
    const classes = useStyles();
    const {firstName, lastName, email, handleDelete} = props;
    return (
        <Grid container alignItems="center" justify="space-between" className={classes.container}>
            <Grid item>
                <List className={classes.root}>
                    <ListItem>
                        <ListItemAvatar>
                            <Avatar>
                                <Person />
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText primary={firstName + ' ' + lastName} secondary={email} />
                    </ListItem>
                </List>
            </Grid>
            <Grid item>
                <Button onClick={handleDelete}>
                    <Delete color="primary" />
                </Button>
            </Grid>
        </Grid>
    );
}
